import { observer } from 'mobx-react-lite';
import * as React from 'react';

export interface HeaderContainerProps {
    header: string;
    children?: React.ReactNode;
    className?: string;
}

const HeaderContainer = observer(
    function HeaderContainer(props: HeaderContainerProps, ref: React.Ref<HTMLDivElement>) {
        return (
            <div ref={ref}>
                <div className={props.className}>{props.header}</div>
                {props.children}
            </div>
        );
    },
    { forwardRef: true }
);
export default HeaderContainer;
